import React from 'react'

type ModalHeaderProps = {
  headerText: string
  onClose: () => void
}

export const ModalHeader = ({ headerText, onClose }: ModalHeaderProps) => {
  return (
    <div className='flex justify-between items-center bg-[#ebf3ff] rounded-t-lg h-12 md:h-16 md:gap-[100px] tracking-wide flex-wrap px-6'>
      <h4 className='text-[#001A3D] md:text-[#020251] text-sm md:text-2xl font-normal md:font-bold tracking-wide'>
        {headerText}
      </h4>
      <button onClick={onClose}>
        <svg
          className='w-4 h-4 md:w-6 md:h-6'
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M18 6L6 18'
            stroke='#020251'
            strokeWidth='3'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M6 6L18 18'
            stroke='#020251'
            strokeWidth='3'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      </button>
    </div>
  )
}
